import "./PickQueue.scss";

import { Button, CircularProgress } from "@mui/material";
import {
    backgroundPickQueue,
    iconQueueUmum,
    kfIconGroup
} from "assets/images";
import FullScreenPage from "components/fullscreen";
import { QueueItem } from "models/queue-item.model";
import React, { useEffect, useState } from "react";
import { connect as reduxConnect } from "react-redux";
import QueueService from "services/queue.service";
import { ApplicationState } from "store";
import { ConfigState } from "store/config/config.reducer";

const queueService = new QueueService();
interface IStateProps {
    configState: ConfigState
}
const mapStateToProps = (state: ApplicationState): IStateProps => ({
    configState: state.configState
})
type Props = IStateProps;

interface ButtonPickQueueProps {
    outletId: string;
    item: QueueItem;
    isWebView: boolean;
    buttonsLoading: Record<string, boolean>;
    setButtonsLoading: (value: Record<string, boolean>) => void;

}
const ButtonPickQueue = (props: ButtonPickQueueProps): JSX.Element => {
    const {outletId, item, isWebView, buttonsLoading, setButtonsLoading} = props;
    const onClickButtonQueue = React.useCallback(() => {
        const idQueue = item.id;
        setButtonsLoading({...buttonsLoading, [`${idQueue}`]: true});
        queueService.addQueue(outletId, idQueue)
            .then(
                ({ data }) => {
                    if (data?.result) {
                        setButtonsLoading({...buttonsLoading, [`${idQueue}`]: false});
                        const { result } = data;
                        const url = `app://com.kimiafarma.printingservices?` +
                            `clinic-name=${result.name}&clinic-address=${result.address}` +
                            `&queue-number=${result.number}`;

                        const win: Window = window;
                        win.location = url
                    }
                    return data;
                },
                () => {
                    setButtonsLoading({...buttonsLoading, [`${idQueue}`]: false});
                }
            )
            .catch(() => setButtonsLoading({...buttonsLoading, [`${idQueue}`]: false}))
    }, []);

    return (
        <Button variant='contained' classes={{ root: 'pick-queue-item' }}
                data-itemid={item.id}
                disabled={buttonsLoading[`${item.id}`]}
                onClick={onClickButtonQueue}
                sx={isWebView ? {margin: '2rem !important'} : {}}>
                    <img style={{ height: "10rem" }}
                        src={decodeURI(item?.imageUrl)}
                        alt="pick-queue-image"
                        onError={({currentTarget}) => {
                            const key = "onerror";
                            currentTarget[key] = null;
                            currentTarget.src = iconQueueUmum;
                        }}
                    />
                <div className='title-item'>
                    <span className='title-text'>
                        {item.buttonName}
                    </span>
                    {buttonsLoading[`${item.id}`] &&
                        <CircularProgress size={20} sx={{marginLeft: "3px"}}/>
                    }
                </div>
            </Button>
    )
}

const PickQueue = (props: Props) => {
    const [listQueue, setListQueue] = useState<QueueItem[]>([]);
    const outletId = props.configState.outletId || '';
    const [buttonsLoading, setButtonsLoading ] = useState<Record<string, boolean>>({});
    const [isWebView, setIsWebView ] = useState<boolean>(false);

    useEffect(() => {
        queueService.getAll(outletId).then(({ data }) => {
            if (data?.result) {
                setListQueue(data.result);
            }
            return data;
        })
        .catch(error => console.error(error) );

        if (window.navigator.userAgent === 'KFLabApp-Web-View') {
            setIsWebView(true);
        }
    }, []);

    return (
        <React.Fragment>
            <div className="w-screen h-screen bg-cover p-16" id="pick-queue"
                style={{ backgroundImage: `url(${backgroundPickQueue})`, zIndex: 1 }}>
                <FullScreenPage pageId="pick-queue" />
                <div className='flex justify-center items-center self-center h-full'>
                    <div className="h-full flex flex-col self-center justify-center content-pick-queue-wrapper">
                        <div className='flex justify-between items-center header-pick-queue'>
                            <div className='font-bold text-5xl text-[#3A3A3C] title-get-queue'>
                                AMBIL ANTRIAN
                            </div>
                            <img src={kfIconGroup} alt="" className='h-[12rem]' />
                        </div>
                        <div className='flex justify-between flex-wrap list-button-action'>
                            <div className='font-bold text-6xl text-[#3A3A3C] w-full text-center
                                title-get-queue-mini-size'>
                                AMBIL ANTRIAN
                            </div>
                            {listQueue.map(item => item.status &&
                                <ButtonPickQueue key={item.id} {...{
                                    item, isWebView, buttonsLoading, setButtonsLoading, outletId
                                }} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default reduxConnect(mapStateToProps)(PickQueue);